"use client";

import {
  Search,
  Hotel,
  BarChart3,
  Link,
  CreditCard,
  Bell,
  Trash2,
  UserCircle,
} from "lucide-react";
import TextWave from "./TextWave";

const TOOL_DISPLAY: Record<string, { label: string; icon: React.ElementType }> =
  {
    search_hotels: { label: "Searching hotels", icon: Search },
    get_hotel_details: { label: "Getting hotel details", icon: Hotel },
    get_hotel_rates: { label: "Checking hotel rates", icon: Hotel },
    compare_rates: { label: "Comparing rates", icon: BarChart3 },
    get_booking_link: { label: "Getting booking link", icon: Link },
    book_hotel: { label: "Processing booking", icon: CreditCard },
    get_payment_methods: {
      label: "Fetching payment methods",
      icon: CreditCard,
    },
    get_rate_alerts: { label: "Checking rate alerts", icon: Bell },
    create_rate_alert: { label: "Creating rate alert", icon: Bell },
    delete_rate_alert: { label: "Removing rate alert", icon: Trash2 },
    update_traveler_profile: {
      label: "Saving preference",
      icon: UserCircle,
    },
  };

interface ToolCallIndicatorProps {
  toolName: string;
  isLoading: boolean;
  label?: string;
}

export default function ToolCallIndicator({
  toolName,
  isLoading,
  label,
}: ToolCallIndicatorProps) {
  const display = TOOL_DISPLAY[toolName] || { label: toolName, icon: Search };
  const visibleLabel = label ?? display.label;
  const Icon = display.icon;

  return (
    <div className="flex items-center gap-2 rounded-lg border border-border bg-card px-3 py-2">
      {isLoading ? (
        <TextWave text={`${visibleLabel}...`} />
      ) : (
        <Icon className="h-4 w-4 text-primary" />
      )}
      {isLoading ? null : (
        <span className="text-sm text-muted-foreground">{visibleLabel}...</span>
      )}
    </div>
  );
}
